import { render, staticRenderFns } from "./SharerAction.vue?vue&type=template&id=06e63894&scoped=true"
import script from "./SharerAction.vue?vue&type=script&lang=js"
export * from "./SharerAction.vue?vue&type=script&lang=js"
import style0 from "./SharerAction.vue?vue&type=style&index=0&id=06e63894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e63894",
  null
  
)

export default component.exports